import { render, staticRenderFns } from "./DepartmentInfo.vue?vue&type=template&id=e5daaed0"
import script from "./DepartmentInfo.ts?vue&type=script&lang=ts&external"
export * from "./DepartmentInfo.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports